import { axiosClient } from "../../common/api/axios-client";
import { AppState } from "../../common/store/app-state/app-state-slice";
import emitVurbalizeEvent from "./emit-vurbalize-event";
import getCommonData from "./get-common-data";

export const sendMessageLog = async (logData:any, state: AppState) => {
  try {
    const data_object:any = getCommonData(state);
    const log_timestamp = parseFloat((Date.now() / 1000).toFixed(6));
    logData['log_timestamp'] = log_timestamp;
    data_object['log_type'] = 'frontend';
    data_object['properties'] = logData;

    // Check if event_name exists in log_data and dispatch event
    if (logData?.event_name && logData?.event_data) {
      emitVurbalizeEvent(state, logData.event_name, logData?.event_data);
    }

    const result = await axiosClient.post(
      '/external_logs',
      data_object
    )

    return result;
  } catch (err) {
    console.error("autocompleteData", err);
  }
}

export default sendMessageLog;
